module.exports = __webpack_public_path__ + "img/phone.0dd579b.svg";